import { useState } from 'react';
import { FileSpreadsheet, FileText, Loader2 } from 'lucide-react';
import { downloadExceptionExport } from './downloadExceptionExport';

export default function ExceptionExportButtons({
  filters = {},
  total = 0,
  disabled = false,
  className = '',
}) {
  const [exporting, setExporting] = useState(null);
  const [error, setError] = useState('');

  const runExport = async (format) => {
    setExporting(format);
    setError('');
    try {
      await downloadExceptionExport(format, filters);
    } catch (e) {
      setError(e.message || 'Export failed');
    } finally {
      setExporting(null);
    }
  };

  return (
    <div className={`flex flex-wrap items-center gap-2 ${className}`}>
      <span className="text-xs text-slate-500">
        Export{total > 0 ? ` (${total.toLocaleString()} row${total === 1 ? '' : 's'})` : ''}
        {Object.values(filters).some((v) => v != null && String(v).trim() !== '')
          ? ' · current filters'
          : ' · all exceptions'}
      </span>
      <button
        type="button"
        disabled={disabled || !!exporting}
        onClick={() => runExport('xlsx')}
        className="btn-secondary py-1.5 text-xs"
      >
        {exporting === 'xlsx' ? (
          <Loader2 className="h-3.5 w-3.5 animate-spin" />
        ) : (
          <FileSpreadsheet className="h-3.5 w-3.5" />
        )}
        Excel
      </button>
      <button
        type="button"
        disabled={disabled || !!exporting}
        onClick={() => runExport('pdf')}
        className="btn-secondary py-1.5 text-xs"
      >
        {exporting === 'pdf' ? (
          <Loader2 className="h-3.5 w-3.5 animate-spin" />
        ) : (
          <FileText className="h-3.5 w-3.5" />
        )}
        PDF
      </button>
      {error && <span className="text-xs text-rose-400">{error}</span>}
    </div>
  );
}
